// extracted by mini-css-extract-plugin
export default {"searchInput":"jOTAJQO4"};